import { Fab } from '@mui/material';

import { setDefaultOptions } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { ReactComponent as DeIcon } from 'flag-icons/flags/4x3/de.svg';
import { ReactComponent as EnIcon } from 'flag-icons/flags/4x3/gb.svg';

import i18next from 'locales/i18n';

const handleLanguageChange = () => {
  if (i18next.language === 'de') {
    setDefaultOptions({ locale: enUS });
    i18next.changeLanguage('en');
  } else {
    setDefaultOptions({ locale: de });
    i18next.changeLanguage('de');
  }
};

export const LanguagePicker = () => {
  return (
    <Fab size="small" className="action" onClick={handleLanguageChange}>
      {i18next.language === 'de' ? (
        <DeIcon width={28} height={28} />
      ) : (
        <EnIcon width={28} height={28} />
      )}
    </Fab>
  );
};
